import type { Buffer } from "../model/buffer";
import type { Cursor } from "../model/cursor";
import type { Range } from "../model/range";
import { bracketTextObject } from "./bracket";
import { quoteTextObject } from "./quote";
import { wordTextObject } from "./word";

export type TextObjectName = "iw" | "aw" | 'i"' | 'a"' | "i(" | "a(" | "i{" | "a{";

export type TextObjectFn = (buffer: Buffer, cursor: Cursor) => Range | null;

export const TEXT_OBJECTS: ReadonlyMap<TextObjectName, TextObjectFn> = new Map<
  TextObjectName,
  TextObjectFn
>([
  ["iw", (buffer, cursor) => wordTextObject(buffer, cursor, false)],
  ["aw", (buffer, cursor) => wordTextObject(buffer, cursor, true)],
  ['i"', (buffer, cursor) => quoteTextObject(buffer, cursor, '"', false)],
  ['a"', (buffer, cursor) => quoteTextObject(buffer, cursor, '"', true)],
  ["i(", (buffer, cursor) => bracketTextObject(buffer, cursor, "(", ")", false)],
  ["a(", (buffer, cursor) => bracketTextObject(buffer, cursor, "(", ")", true)],
  ["i{", (buffer, cursor) => bracketTextObject(buffer, cursor, "{", "}", false)],
  ["a{", (buffer, cursor) => bracketTextObject(buffer, cursor, "{", "}", true)],
]);

/** `i`/`a` + オブジェクト文字から、対応するテキストオブジェクト識別子を得る。 */
export function resolveTextObjectName(
  prefix: "i" | "a",
  objectChar: string,
): TextObjectName | null {
  const key = objectChar === ")" ? "(" : objectChar === "}" ? "{" : objectChar;
  const candidate = `${prefix}${key}`;
  return TEXT_OBJECTS.has(candidate as TextObjectName) ? (candidate as TextObjectName) : null;
}
